module.exports = __webpack_public_path__ + "img/Operations.17125ef3.svg";